import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';
import { toggleModal } from 'data/actions/modals';
import { deleteOptOutContacts } from 'data/actions/sequences';
import { modalsSelector, modalOptionsSelector } from 'data/selectors/modals';
import { Container } from '../deleteStep/styles';
import { ModalTitle, CloseIcon, Footer } from '../baseModal/styles';

const DeleteUnsubscribesModal = () => {
  const dispatch = useDispatch();

  const { visible } = useSelector(modalsSelector);
  const { emails, setSelectedRowKeys } = useSelector(modalOptionsSelector);

  const handleClose = () => dispatch(toggleModal('delete_unsubscribes', false));
  const handleDelete = () => {
    dispatch(deleteOptOutContacts(emails));
    dispatch(toggleModal('delete_unsubscribes', false));
    if (setSelectedRowKeys) setSelectedRowKeys([]);
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle danger>
          Delete {emails.length === 1 ? 'unsubscription' : 'unsubscriptions'}
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={handleClose}
    >
      <Container>
        <div>
          You&#39;re about to delete the {emails.length === 1 ? 'unsubscription' : 'unsubscriptions'}. Deleted{' '}
          {emails.length === 1 ? 'unsubscriptions' : 'unsubscription'} can&#39;t be restored
        </div>
      </Container>
      <Footer>
        <Button data-form="true" type="danger" size="large" onClick={handleDelete}>
          Delete
        </Button>
        <Button size="large" type="default" onClick={handleClose}>
          No
        </Button>
      </Footer>
    </Modal>
  );
};

export default DeleteUnsubscribesModal;
